import { IconProps } from './icons-props';

function ArchiveFillIcon({ className, width = 24, height = 24 }: IconProps) {
    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox='0 0 18 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M13.8203 0H4.18031C2.05031 0 0.320312 1.74 0.320312 3.86V17.95C0.320312 19.75 1.61031 20.51 3.19031 19.64L8.07031 16.93C8.59031 16.64 9.43031 16.64 9.94031 16.93L14.8203 19.64C16.4003 20.52 17.6903 19.76 17.6903 17.95V3.86C17.6803 1.74 15.9503 0 13.8203 0ZM12.0103 7.75C11.0403 8.1 10.0203 8.28 9.00031 8.28C7.98031 8.28 6.96031 8.1 5.99031 7.75C5.60031 7.61 5.40031 7.18 5.54031 6.79C5.69031 6.4 6.12031 6.2 6.51031 6.34C8.12031 6.92 9.89031 6.92 11.5003 6.34C11.8903 6.2 12.3203 6.4 12.4603 6.79C12.6003 7.18 12.4003 7.61 12.0103 7.75Z'
                fill='currentColor'
            />
        </svg>
    );
}

export default ArchiveFillIcon;

